'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'clsx';
import { useLenis } from 'lenis/react';
import { useEffect, useRef, useState } from 'react';
import { Button } from '~/components/button';
import { Link } from '~/components/link';
import { useStore } from '~/libs/store';
import { Time } from './(components)/time';
import s from './real-footer.module.css';
const INSPIRATION_LINKS = {
  video: ['https://www.youtube.com/watch?v=GoombqVS-u4', 'https://www.youtube.com/watch?v=GO5FwsblpT8', 'https://www.youtube.com/watch?v=ZexvTZ1sV8U'],
  song: ['https://www.youtube.com/watch?v=P7YMI39sObY', 'https://www.youtube.com/watch?v=FQlAEiCb8m0', 'https://www.youtube.com/watch?v=XojqgVtBbHw'],
  book: ['https://www.goodreads.com/book/show/40604658-jurassic-park', 'https://www.goodreads.com/book/show/60965426-the-creative-act?ref=nav_sb_ss_1_12', 'https://www.goodreads.com/book/show/70720.Le_Petit_Prince'],
  game: ['https://thatgamecompany.com/journey/', 'https://www.starwars.com/games-apps/knights-of-the-old-republic'],
  movie: ['https://www.imdb.com/title/tt0062622/', 'https://www.imdb.com/title/tt0083658/', 'https://www.imdb.com/title/tt0133093/']
};
const TITLES = {
  video: 'Important video',
  song: 'A meaningful Song',
  book: 'Great book btw',
  game: 'Amazing game',
  movie: 'A good movie'
};
export function RealFooter() {
  const $ = _c(26);
  const footerRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [randomLinks, setRandomLinks] = useState(t0);
  const setIsFooterFullyInView = useStore(_temp);
  const lastScrollY = useRef(0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const links_0 = Object.entries(INSPIRATION_LINKS).map(_temp2);
      setRandomLinks(links_0);
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== setIsFooterFullyInView) {
    t3 = lenis => {
      if (footerRef.current) {
        const progress = calculateProgress(lenis.dimensions.scrollHeight - lenis.dimensions.height, footerRef.current.offsetHeight, lenis.scroll);
        setIsFooterFullyInView(progress >= 0.1);
        lastScrollY.current = lenis.scroll;
      }
    };
    $[3] = setIsFooterFullyInView;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useLenis(t3);
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn(s.wrapper, "relative overflow-clip bg-primary z-10");
    t5 = cn(s.stickyWrapper, "absolute bottom-0 left-0 right-0");
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn(s.footer, "bg-primary sticky top-header-height bottom-0 left-0 right-0 dr-layout-grid-inner py-safe");
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button href="/contact" className="col-start-1 col-span-full dt:col-span-1">Let's talk</Button>;
    t8 = <Time />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="caption smb-24 dt:smb-40">Nav</p>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <nav className="col-span-2 dt:col-span-1">{t9}<ul className="p"><li><Link className="cta-hover" href="/">home</Link></li><li><Link className="cta-hover" href="/work">work</Link></li><li><Link className="cta-hover" href="/read">read</Link></li><li><Link className="cta-hover" href="/about">about</Link></li><li><Link className="cta-hover" href="/contact">contact</Link></li></ul></nav>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="caption smb-24 dt:smb-40">open source</p>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <nav className="col-span-2 dt:col-span-1">{t11}<ul className="p"><li><Link className="cta-hover" href="https://github.com/darkroomengineering/satus">satus</Link></li><li><Link className="cta-hover" href="https://github.com/darkroomengineering/lenis">lenis</Link></li><li><Link className="cta-hover" href="https://github.com/darkroomengineering/hamo">hamo</Link></li><li><Link className="cta-hover" href="https://github.com/darkroomengineering/tempus">tempus</Link></li><li><Link className="cta-hover" href="https://github.com/darkroomengineering/omnes">Omnes</Link></li></ul></nav>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="caption smb-24 dt:smb-40">social</p>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <nav className="col-span-2 dt:col-span-1">{t13}<ul className="p"><li><Link className="cta-hover" href="https://github.com/darkroomengineering">github</Link></li><li><Link className="cta-hover" href="https://x.com/darkroomdevs">X (twitter)</Link></li><li><Link className="cta-hover" href="https://www.instagram.com/darkroom.engineering">Instagram</Link></li><li><Link className="cta-hover" href="https://www.linkedin.com/company/darkroom-engineering">LinkedIn</Link></li></ul></nav>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p className="caption smb-24 dt:smb-40">Inspiration</p>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== randomLinks) {
    t16 = randomLinks.map(_temp3);
    $[17] = randomLinks;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t16) {
    t17 = <section className="h-min dt:spt-50 col-span-full grid grid-cols-subgrid dt:sgap-y-40 sgap-y-20 uppercase items-start relative z-2">{t7}{t8}{t10}{t12}{t14}<nav className="col-span-2 dt:col-span-1">{t15}<ul className="p">{t16}</ul></nav></section>;
    $[19] = t16;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <p className={cn(s.darkroom, "col-span-full text-center z-2")}>darkroom</p>;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  let t20;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <section className="relative z-10 col-span-full flex justify-between uppercase items-end"><p className="caption">©2025 darkroom.engineering</p><p className="caption text-end">all rights reserved</p></section>;
    t20 = <div className={cn(s.lines, "absolute bottom-0 left-0 right-0")} />;
    $[22] = t19;
    $[23] = t20;
  } else {
    t19 = $[22];
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t17) {
    t21 = <div className={t4}><div className={t5}><footer ref={footerRef} className={t6}>{t17}{t18}{t19}{t20}</footer></div></div>;
    $[24] = t17;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  return t21;
}
function _temp3(link, index) {
  return <li key={`${link.category}-${index}`}><Link href={link.href} className="cta-hover" target="_blank" rel="noopener noreferrer">{TITLES[link.category]}</Link></li>;
}
function _temp2(t0) {
  const [category, links] = t0;
  return {
    category,
    href: links[Math.floor(Math.random() * links.length)]
  };
}
function _temp(state) {
  return state.setIsFooterFullyInView;
}
function calculateProgress(scrollHeight, elementHeight, scrollValue) {
  const triggerPoint = scrollHeight - elementHeight;
  if (scrollValue < triggerPoint) {
    return 0;
  }
  return Math.min(1, (scrollValue - triggerPoint) / elementHeight);
}